export const TRACKING_PREFIX = 'Guest Engagement: Loyalty Sign up - '
